import { Box, DialogTitle, IconButton } from '@mui/material';

import { H1, P1R } from 'src/components/Typography';
import Icon from 'src/components/Icon';
import { ModalTitleProps } from '../components.types';

function StyledDialogTitle(props: ModalTitleProps) {
  const { children, onClose, disableShadow, ...other } = props;

  return (
    <DialogTitle
      sx={{
        m: 0,
        p: 2,
        pt: 5,
        pb: 0,
        ...(!disableShadow && {
          boxShadow: '0px 24px 28px 25px #fff',
          zIndex: 1,
          pb: 0,
        }),
      }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: '8px',
            top: '8px',
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Icon name="close" />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const ModalTitle = ({ onClose, id, customTitle, subTitle, icon, disableShadow }: ModalTitleProps) => {
  return (
    <StyledDialogTitle id={id} onClose={onClose} disableShadow={disableShadow}>
      {icon ? (
        <Box display="flex" justifyContent="center" marginBottom={4}>
          <img src={icon} alt="action" />
        </Box>
      ) : null}
      <H1 align="center">{customTitle}</H1>
      <P1R sx={{ paddingTop: 2, textAlign: 'center', display: 'block' }}>{subTitle}</P1R>
    </StyledDialogTitle>
  );
};

export default ModalTitle;
